// Modules
import { gql } from '@apollo/client'

export const ConfirmToken = gql`
    mutation confirmToken($dataConfirmation: PatientToken!, $logInfo: LogInfoInput) {
        confirmToken(patientToken: $dataConfirmation, logInfo: $logInfo) {
            message
            authentication {
                access_token
                refresh_token
            }
        }
    }
`
export const CreateLogin = gql`
    mutation createLogin($patient: PatientLogin, $logInfo: LogInfoInput) {
        createLogin(patient: $patient, logInfo: $logInfo) {
            message
            cipIntegrationStatus
            examsIntegrationStatus
        }
    }
`

export const ResendToken = gql`
    mutation resendToken($patient: ResendTokenPatient!, $logInfo: LogInfoInput) {
        resendToken(patient: $patient, logInfo: $logInfo) {
            message
        }
    }
`

export const ResendTokenV2 = gql`
    mutation resendTokenV2($patient: ResendTokenPatientV2!, $logInfo: LogInfoInput) {
        resendTokenV2(patient: $patient, logInfo: $logInfo) {
            message
        }
    }
`

export const CreatePatientAccount = gql`
    mutation createPatientAccount($patient: CreatePatientInput!, $logInfo: LogInfoInput) {
        createPatientAccount(patient: $patient, logInfo: $logInfo) {
            cipIntegrationStatus
            examsIntegrationStatus
            patient {
                id
            }
        }
    }
`

export const AssociateCip = gql`
    mutation associateCip($tokenCIP: String!) {
        associateCip(tokenCIP: $tokenCIP) {
            status
        }
    }
`

export const RefreshToken = gql`
    mutation refreshToken($token: String!, $KeepLogged: KeepLoggedRefreshToken) {
        refreshToken(token: $token, KeepLogged: $KeepLogged) {
            access_token
            refresh_token
        }
    }
`
